
export default function CoreValues() {
  const values = [
    {
      icon: 'ri-heart-line',
      title: 'Compassion First',
      description: 'We understand the fear and uncertainty that comes with genetic heart disease. Every interaction is guided by empathy and genuine care for our patients and their families.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Scientific Excellence',
      description: 'Our genetic testing and medical consultations are backed by the latest research and delivered by board-certified specialists in cardiovascular genetics.',
    },
    {
      icon: 'ri-team-line',
      title: 'Community Focus',
      description: 'We\'re committed to raising awareness in underserved communities, particularly South Asian populations where FH prevalence is high but diagnosis rates remain low.',
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovation & Accessibility',
      description: 'We leverage technology to make genetic testing affordable and consultations convenient, removing barriers that prevent families from getting the care they need.',
    },
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20">
        <div className="text-center mb-10 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            Our Core Values
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            These principles guide everything we do at Vazcular
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-teal-50 to-white p-6 sm:p-8 rounded-xl sm:rounded-2xl border border-teal-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-teal-600 rounded-full flex items-center justify-center mb-4 sm:mb-5 lg:mb-6 shadow-lg">
                <i className={`${value.icon} text-white text-2xl sm:text-3xl lg:text-4xl`}></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3">
                {value.title}
              </h3>
              <p className="text-sm sm:text-base lg:text-lg text-gray-700 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
